// Report History (Identity/Billing roadmap, Phase 3). Lists the account's auto-saved reports (from
// /api/reports, gated on 'team_history'); "Open" re-fetches the stored data and re-renders + re-prints
// the same PDF via a handler main.ts provides (it owns the report renderer). Reuses the Team Trends
// table styles. Fails quiet.

import * as api from '../lib/api.js';

function h<K extends keyof HTMLElementTagNameMap>(tag: K, cls?: string, text?: string): HTMLElementTagNameMap[K] {
  const n = document.createElement(tag);
  if (cls) n.className = cls;
  if (text !== undefined) n.textContent = text;
  return n;
}

let openHandler: ((id: string) => void) | null = null;
/** main.ts wires this — it fetches the saved report and re-renders + prints it. */
export function setReportOpener(fn: (id: string) => void): void {
  openHandler = fn;
}

function fmtDate(ms: number): string {
  try {
    return new Date(ms).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return '';
  }
}

export function renderHistory(): void {
  const root = document.getElementById('history-app');
  if (!root) return;
  root.textContent = '';
  root.appendChild(h('p', 'tt-loading', 'Loading history…'));
  api
    .listReports()
    .then((res) => paint(root, res.reports))
    .catch(() => {
      root.textContent = '';
      root.appendChild(h('p', 'tt-empty', 'History is unavailable right now. Please try again.'));
    });
}

function paint(root: HTMLElement, reports: api.SavedReport[]): void {
  root.textContent = '';
  if (!reports.length) {
    root.appendChild(h('p', 'tt-empty', 'No saved reports yet. Turn on “Auto-save reports” in Account, then download a report and it will appear here.'));
    return;
  }

  const head = h('div', 'tt-head');
  head.appendChild(h('h3', 'tt-h', 'Saved reports'));
  head.appendChild(h('span', 'tt-count', `${reports.length} report${reports.length === 1 ? '' : 's'}`));
  root.appendChild(head);

  const scroll = h('div', 'tt-scroll');
  const table = h('table', 'tt-table');
  const thead = h('thead');
  const htr = h('tr');
  ['Rep', 'Call type', 'Account', 'Score', 'Saved', ''].forEach((c) => htr.appendChild(h('th', undefined, c)));
  thead.appendChild(htr);
  table.appendChild(thead);

  const tbody = h('tbody');
  for (const r of reports) {
    const tr = h('tr');
    tr.appendChild(h('td', 'tt-rep-name', r.rep_name || 'Unnamed rep'));
    tr.appendChild(h('td', undefined, r.call_type || '—'));
    tr.appendChild(h('td', undefined, r.business || '—'));
    tr.appendChild(h('td', 'tt-num', r.final_score === null ? '—' : r.final_score.toFixed(1)));
    tr.appendChild(h('td', undefined, fmtDate(r.ts)));
    const act = h('td');
    const open = h('button', 'acct-link', 'Open & download');
    open.type = 'button';
    open.addEventListener('click', () => openHandler?.(r.report_id));
    act.appendChild(open);
    tr.appendChild(act);
    tbody.appendChild(tr);
  }
  table.appendChild(tbody);
  scroll.appendChild(table);
  root.appendChild(scroll);
}
